import React from 'react';
import AskModal from './AskModal';

const AskRemoveModal = ({
  visible,
  onConfirm,
  onCancel,
  text,
  isHolding,
  expire,
  lockerInfo,
}) => {
  let description = '';
  
  if (lockerInfo && lockerInfo.selectBlock) {
    const blockArray = Array.isArray(lockerInfo.selectBlock) 
      ? lockerInfo.selectBlock 
      : [lockerInfo.selectBlock];
    
    if (blockArray.length > 0) {
      const lockerName = blockArray[0].name;
      const minSN = Math.min(...blockArray.map(l => l.lockerSN));
      const maxSN = Math.max(...blockArray.map(l => l.lockerSN));
      const count = blockArray.length;
      
      description = isHolding
        ? `홀드를 해제하시겠습니까?`
        : expire
        ? `${text}를 정말 비우시겠습니까?`
        : `"${lockerName}" (${minSN}번 ~ ${maxSN}번, 총 ${count}개)을(를) 정말 삭제하시겠습니까?`;
    }
  }
  
  if (!description) {
    description = isHolding
      ? `홀드를 해제하시겠습니까?`
      : expire
      ? `${text}를 정말 비우시겠습니까?`
      : `${text}을(를) 정말 삭제하시겠습니까?`;
  }
  
  return (
    <AskModal
      visible={visible}
      title={
        isHolding ? `홀드 해제` : expire ? `${text} 비우기` : `${text} 삭제`
      }
      description={description}
      confirmText={isHolding ? '해제' : expire ? '확인' : '삭제'}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default AskRemoveModal;
